export const VERSION = '1.0.7';
export const PHONE = '919582822225';
